import { render } from "./ArrowIcon.vue?vue&type=template&id=3aca4878"
import script from "./ArrowIcon.vue?vue&type=script&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__